$(() => {
  // 編集ボタンクをリックで、メッセージ編集エリアを表示
  $('.js-edit-message-button').on('click', function () {
    const messageId = $(this).data('message-id');
    const messageLabelArea = $('#js-message-label-' + messageId);
    const messageTextArea = $('#js-textarea-message-' + messageId);
    const messageButton = $('#js-message-button-' + messageId);

    messageLabelArea.hide();
    messageTextArea.css({ cssText: 'display: block !important;' });
    messageButton.css({ cssText: 'display: block !important;' });
  });

  // キャンセルボタンをクリックで、メッセージ編集エリアを非表示
  $('.message-cancel-button').on('click', function () {
    const messageId = $(this).data('cancel-id');
    const messageLabelArea = $('#js-message-label-' + messageId);
    const messageTextArea = $('#js-textarea-message-' + messageId);
    const messageButton = $('#js-message-button-' + messageId);
    const messageError = $('#js-message-post-error-' + messageId);

    messageLabelArea.show();
    messageTextArea.hide();
    messageButton.hide();
    messageError.hide();
  });

  // 更新ボタンをクリックで、メッセージを更新
  $('.message-update-button').on('click', function () {
    const messageId = $(this).data('update-id');
    const textField = $('#js-textarea-message-' + messageId).children(
      'textarea'
    );
    const body = textField.val();

    $.ajax({
      url: '/negotiation_messages/' + messageId,
      type: 'PATCH',
      data: {
        negotiation_message: {
          content: body,
        },
      },
    }).done(function (data) {
      const messageLabelArea = $('#js-message-label-' + messageId);
      const messageTextArea = $('#js-textarea-message-' + messageId);
      const messageButton = $('#js-message-button-' + messageId);
      const messageError = $('#js-message-post-error-' + messageId);
      const messageEdited = $('#js-message-edited-' + messageId);
      const exp =
        /((https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

      messageLabelArea.show();
      messageLabelArea.text(data.content);
      messageLabelArea.html(
        messageLabelArea.html().replace(exp, "<a href='$1'>$1</a>")
      );
      messageTextArea.hide();
      messageButton.hide();
      messageError.hide();
      messageEdited.removeClass('d-none');
    });
  });
});
